module.exports = __webpack_public_path__ + "static/media/ticket_campaign_preview_related_brand_pic.68763edf.svg";